/*
 *  @providesModule Divider
 *  
 */


import React from "react";

import LinearGradient from "react-native-linear-gradient";
import PropTypes from 'prop-types';
import SkillzStyle from "SkillzStyle";

class Divider extends React.Component {

  static propTypes = {
    dividerColor: PropTypes.string.isRequired,
    style: PropTypes.any.isRequired,
  };

  render(): React.ReactNode {
    const dividerColorMain = this.props.dividerColor;
    const dividerColor = SkillzStyle.convertToOpacity(dividerColorMain, 0.5);
    const dividerAlphaColor = SkillzStyle.convertToOpacity(dividerColorMain, 0.1);

    // Note: only works for Horizontal Dividers at the moment
    return (
      <LinearGradient style={this.props.style}
                      colors={[dividerAlphaColor, dividerColor, dividerAlphaColor]}
                      start={{x:0.0, y:0.4}}
                      end={{x:1.0, y:0.4}}/>
    );
  }

}

export default Divider;
